import util from './tnew-util/src/index.js' // Module import

// Turn on console logging as needed:
util.settings.loggingEnabled = false;

// Call `run` to "patch" standard form controls present on the page
const { customForm, updateFieldGroups } = util.run();

// If the page has a custom form on it, its data will be returned,
// as well as a function to group fields into one or more fieldsets.
// If no custom form is present, both of these will be `undefined`.
if (customForm) {

    // Setup a "default" grouping with legend text, passing back
    // the given fields. This pattern is recommended as to not *require*
    // JS updates to coincide with any future custom form additions.
    let grouping = {
      legend: '',
      fields: customForm.fields,
    };

    // Call `updateFieldGroups` with your grouping. For each `FieldGroup`
    // object provided, a fieldset will be created (if needed), a legend
    // will be created, and the fields will be inserted in the given order.
    updateFieldGroups(grouping);
}

/**
 * Returns a new label element
 *
 * @param {string} text Text for label
 * @param {string} htmlFor Label for attribute
 */
function createLabel(text, htmlFor)
{
    const label = document.createElement("label");

    label.appendChild(
      document.createTextNode(text)
    );

    label.className = "sr-only";
    label.htmlFor = htmlFor;

    return label;
}

/**
 * Creates and inserts a label element into the DOM for
 * a specifed element
 *
 * @param {string} text Label text
 * @param {string} elementSelector Selector of the element to create the label for
 */
function insertLabelBeforeElement(text, elementSelector)
{
  const input = document.querySelector(elementSelector);

  if (input) {
    input.parentNode.insertBefore(
      createLabel(text, input.id),
      input
    );
  }
}

/**
 * Changes a HTML tag to another.
 *
 * @param {string|object} item The item to change
 * @param {string} to The tag to create
 * @param {callable} callback Called before the original item is replaced.
 */
function changeElementTag(item, to, callback)
{
  if (typeof item === 'string') {
    item = document.querySelector(item);
  }

  if (item) {
    let replacement = document.createElement(to);
    replacement.innerHTML = item.innerHTML;

    if (callback) {
      replacement = callback(replacement, item);
    }

    item.parentNode.insertBefore(replacement, item);
    item.remove();
  }
}

/**
 *
 * To achieve heading hierarchy on SYOS page, change the SYOS header from h2 to h3
 * https://github.com/TheScienceMuseum/tnew/issues/80
 */
$("h2:contains('Choose your own seat')").replaceWith( "<h3 class='sr-only'>Choose your own seat</h3>" );

/**
 *
 * Add a legend element to the pricetype selector fieldset, despite it not being used in favour of the custom table
 * https://github.com/TheScienceMuseum/tnew/issues/34
 */
$(".tn-ticket-selector__pricetype-selector").prepend( "<legend class='sr-only'>Available Prices</legend>" );


/**
 *
 * No h4 allowed within label, replacing with span
 * https://github.com/TheScienceMuseum/tnew/issues/34
 */

$('.tn-ticket-selector__pricetype-label-heading h4').replaceWith(function(){
  var txt = $(this).text();
  return "<span class='tn-ticket-selector__pricetype-label-heading'>"+txt+"</div>";
});


/**
 *
 * Adjust promo code placeholder to lowercase
 * https://github.com/TheScienceMuseum/tnew/issues/34
 */

$("#tn-subnav-promo-code").attr( "placeholder", "Promo code" );




/**
 *
 * Below is the function invocations that alter the DOM
 *
 */




 insertLabelBeforeElement("Select Day", "#tn-event-calendar-input-day");
 insertLabelBeforeElement("Select Week", "#tn-event-calendar-input-week");
 insertLabelBeforeElement("Select Month", "#tn-event-calendar-input-month");

/**
 * Add a label tag to the promo code box.
 */
insertLabelBeforeElement("Promo Code", "#tn-subnav-promo-code");

/**
 * Change the login form heading
 * Also affects the login information section in account/update section
 */
changeElementTag('.tn-login-component fieldset h2', 'legend');

/**
 * Change the h2 tag in the account information form to a legend tag.
 */
changeElementTag('.tn-patron-component fieldset h2', 'legend');

/**
 * Change the h2 tag in the account address form to a legend tag.
 */
changeElementTag('.tn-address-component fieldset h2', 'legend');

// /**
//  * Change the heading on a timed entry event to a legend.
//  */
// changeElementTag('.tn-ticket-selector__heading-available-zones', 'legend', (replacement) => {
//   replacement.className = 'tn-ticket-selector__heading-available-zones c-fieldset__title';
//   return replacement;
// });

/**
 * Change the h2 tag in the Select Your Mailing List Preferences form to a legend tag.
 */
changeElementTag('.tn-interests .form-group .control-label', 'legend', (replacement) => {
  replacement.innerHTML = 'Please let us know which of the following you are interested in:';
  replacement.className = 'c-fieldset__title';
  return replacement;
});

/**
 * Change the Select Your Mailing List Preferences section to a field set
 */
changeElementTag('.tn-interests .form-group', 'fieldset', (replacement) => {
  replacement.className = 'form-group';
  return replacement;
});

// /**
//  * Change the Available Times heading on a timed entry form
//  */
// changeElementTag('.tn-ticket-selector__zone-selector .tn-ticket-selector__heading-available-zones', 'legend', (replacement) => {
//   replacement.className = 'tn-ticket-selector__heading-available-zones';
//   return replacement;
// });

/**
 */
(function() {
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver((_, observer) => {
    /**
     * Change events date from date picker
     */
    changeElementTag('.tn-events-list-view__datepicker-container--from .tn-btn-datepicker .sr-only', 'label', (replacement) => {
      replacement.className = '';

      replacement.htmlFor = 'tn-event-list-input-date-from';

      replacement.addEventListener('click', (event) => {
        event.target.nextElementSibling.childNodes[1].click()
      });

      return replacement;
    });

    /**
     * Change events date to date picker
     */
    changeElementTag('.tn-events-list-view__datepicker-container--to .tn-btn-datepicker .sr-only', 'label', (replacement) => {
      replacement.className = '';

      replacement.htmlFor = 'tn-event-list-input-date-to';

      replacement.addEventListener('click', (event) => {
        event.target.nextElementSibling.childNodes[1].click()
      });

      return replacement;
    });

    /**
    * Add a label tag to the daypicker in the events calendar view
    */
    insertLabelBeforeElement("Select Day", "#tn-event-calendar-input-day");
    insertLabelBeforeElement("Select Week", "#tn-event-calendar-input-week");
    insertLabelBeforeElement("Select Month", "#tn-event-calendar-input-month");
  
    // Stop watching for changes
    observer.disconnect();
  });

  // Start observing the target node for configured mutations
  const eventList = document.getElementById("tn-events-list-view");

  if (eventList) {
    setTimeout(() => {
      observer.observe(eventList, { attributes: true, childList: true, subtree: true });
    }, 100);
  }

  // Start observing the target node for configured mutations
  const calendarView = document.getElementById("tn-events-calendar-view");
  
  if (calendarView) {
    setTimeout(() => {
      observer.observe(calendarView, { attributes: true, childList: true, subtree: true });
    }, 100);
  }

}());

/**
 * Reorder the seats in a seat map.
 * This is has been disabled due to the work Tessitura have done
 * on the accessibility of the seat map.
 */
(function () {
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver((_, observer) => {
    var lastSeat;
    const seatMap = document.querySelector('.tn-syos-seat-map__svg');

    if (seatMap) {
      // Stop watching for changes
      observer.disconnect();

      const seats  = document.querySelectorAll('.tn-syos-seat-map__svg > g');
      var seatRows = {};

      seats.forEach((item, i) => {
        let yValue = item.children[0].y.baseVal.value
        seatRows[yValue] = seatRows[yValue] || []
        seatRows[yValue].push(item)
      })

      for(let i in seatRows) {
        seatRows[i].sort((a, b) => { return a.children[0].x.baseVal.value - b.children[0].x.baseVal.value })

        seatRows[i].forEach((seat, n) => {
          seat.remove()
          seat.addEventListener('click', () => {
            lastSeat = seat.children[0]
          })
          seatMap.appendChild(seat)
        })
      }

      const priceSelector = document.querySelector(".tn-syos-price-type-selector")

      if (priceSelector) {
        const priceObserver = new MutationObserver((mutation, observer) => {
          if (priceSelector.style.display == "block") {
            document.querySelector(".tn-modal__btn-close").focus()
          } else {
            setTimeout(function() {
              console.log(priceSelector.style.display, lastSeat);
              if (priceSelector.style.display == "none" && lastSeat) {
                lastSeat.focus()
              }
            }, 250)
          }
        });

        priceObserver.observe(priceSelector, { attributes: true, childList: false, subtree: false })
      }
    }

  });

  // Start observing the target node for configured mutations
  const syosContainer = document.querySelector(".tn-syos");

  if (syosContainer) {
    // observer.observe(syosContainer, { attributes: true, childList: true, subtree: true })
  }
})();
